import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { RDDarkService } from './../dark.service';

@Component({
  selector: 'rd-input',
  template: `<div class="inputContainer {{color}}Input" [class.rdDark]="dark">
  <span class="placeholder" [class.focus]="focus" (click)="changeFocus()">{{placeholder}}</span>
  <input class="input" [type]="type" #input [ngModel]="value" (ngModelChange)="changeValue($event)"
    (keydown)="pressKey($event)" (focus)="focusInput()" (focusout)="unfocusInput()" [disabled]="disabled">
</div>
`,
  styles: [`.inputContainer{--main-color:#ba9e5a;--text-color:black;position:relative;margin-top:20px;transition:all .3s linear}.inputContainer .placeholder{position:absolute;transition:all .2s ease-in;z-index:0;color:var(--text-color)}.inputContainer .placeholder.focus{font-size:12px;-webkit-transform:translateY(-100%);transform:translateY(-100%);color:var(--main-color)}.inputContainer .input{border:none;border-bottom:1px solid #e3e3e3;width:100%;height:100%;z-index:1;background-color:transparent;color:var(--text-color)}.inputContainer .input:focus{border-bottom-width:2px;border-bottom-color:var(--main-color);box-shadow:none}.inputContainer.blackInput{--main-color:black}.inputContainer.greenInput{--main-color:#72ba5a}.inputContainer.blueInput{--main-color:#5a5aba}.inputContainer.blue-lightInput{--main-color:#5aa2ba}.inputContainer.redInput{--main-color:#ba5a5a}.inputContainer.purpleInput{--main-color:#a25aba}.inputContainer.orangeInput{--main-color:#ba8a5a}.inputContainer.rdDark{--text-color:white}`]
})
export class RDInputComponent implements OnInit, OnChanges {

  @Input() value = '';
  @Input() placeholder = '';
  @Input() type = 'text';
  @Input() color = 'gold';
  @Input() disabled = false;

  @Output() valueChange = new EventEmitter<any>();
  @Output() pressEnter = new EventEmitter<any>();

  @ViewChild('input') input;

  public focus = false;
  public dark = false;

  constructor(private darkService: RDDarkService) { }

  ngOnInit() {
    this.focus = (this.value === '' || this.value === null) ? false : true;
    this.darkService.getDarkElement().subscribe(() => {
      this.dark = this.darkService.isDark();
    });
    this.dark = this.darkService.isDark();
  }

  ngOnChanges(changes) {
    this.focus = (this.value === '' || this.value === null) ? false : true;
  }

  changeFocus() {
    this.input.nativeElement.focus();
  }

  changeValue(event) {
    this.value = event;
    this.valueChange.emit(event);
  }

  pressKey(event) {
    if (event.keyCode === 13) {
      this.pressEnter.emit();
    }
  }

  focusInput() {
    this.focus = true;
  }

  unfocusInput() {
    if (this.value === '' || this.value === null) {
      this.focus = false;
    }
  }

}
